var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('images/logo-full.svg'),"alt":"AcreTrader Company Logo","width":"180px","height":"30px","viewBox":"0 0 180 30"}})}
var staticRenderFns = []

export { render, staticRenderFns }